import React, { Component, Fragment } from "react";
import { Button, Modal } from "react-bootstrap";

import { put } from "../../../utils/DeApi";
import { FieldGroup } from "../../../utils/BootstrapUtils";
import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";

class ThemeEdit extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];
    this.state = {
      show: false,
      title: this.props.theme.title || "",
      description: this.props.theme.description || "",
      themeType: this.props.theme.themeType.id
    };

    this.handleShowModal = this._handleShowModal.bind(this);
    this.handleCloseModal = this._handleCloseModal.bind(this);
    this.handleSubmit = this._handleSubmit.bind(this);
    this.handleInputChange = this._handleInputChange.bind(this);
  }

  _handleCloseModal() {
    this.setState({ show: false });
    this.props.onThemeEditing && this.props.onThemeEditing(false);
  }

  _handleShowModal() {
    this.setState({ show: true });
    this.props.onThemeEditing && this.props.onThemeEditing(true);
  }

  _handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({ [name]: value }, this.handleUpdated);
  }

  _handleSubmit(event) {
    event.preventDefault();
    const { title, description, themeType } = this.state;
    const { theme, onThemeUpdated } = this.props;

    const updatePromise = put("/themes/" + theme.id, {
      title: title,
      description: description,
      themeType: themeType
    });
    this.setState({ isUpdating: true, error: "" });

    updatePromise.promise
      .then((response) => {
        this.setState({
          show: false,
          error: "",
          isUpdating: false
        });
        onThemeUpdated(response.data);
      })
      .catch((error) => {
        if (!error.isCanceled) {
          this.setState({
            error: error,
            isUpdating: false
          });
        }
      });
    this.subscribedPromises.push(updatePromise);
  }

  componentWillUnmount() {
    this.subscribedPromises.forEach(function(promise) {
      promise.cancel();
    });
  }

  render() {
    const {
      show,
      error,
      isUpdating,
      title,
      description,
      themeType
    } = this.state;

    const { themeTypes } = this.props;

    const form =
      !themeTypes || isUpdating ? (
        <Loader />
      ) : (
        <form onSubmit={this.handleSubmit} autoComplete="off">
          <Modal.Header closeButton>
            <Modal.Title className="mt-0">
              Update title, type and summary
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FieldGroup
              id="themeTitle"
              name="title"
              label="Theme Title"
              type="text"
              onChange={this.handleInputChange}
              value={title}
              placeholder="Enter theme title"
              autoFocus
              required
              maxLength={81}
              validationState={title.length > 80 || !title ? "error" : null}
            />
            <FieldGroup
              id="themeType"
              name="themeType"
              type="select"
              label="Theme Type"
              onChange={this.handleInputChange}
              componentClass="select"
              placeholder="Select theme type"
              value={themeType}
              required
            >
              <option value="" defaultValue hidden>
                Select theme type
              </option>
              {themeTypes
                .sort((a, b) => {
                  if (a.id < b.id) return -1;
                  if (a.id > b.id) return 1;
                  return 0;
                })
                .map((themeType) => {
                  return (
                    <option value={themeType.id} key={themeType.id}>
                      {themeType.name}
                    </option>
                  );
                })}
            </FieldGroup>
            <FieldGroup
              id="themeDescription"
              name="description"
              label="Theme Summary"
              componentClass="textarea"
              rows={"15"}
              placeholder="Enter theme summary (optional)"
              value={description || ""}
              onChange={this.handleInputChange}
              maxLength={5100}
              validationState={description.length > 5000 ? "error" : null}
            />
            {error && <ErrorHandler error={error} />}
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="link" onClick={this.handleCloseModal}>
              Cancel
            </Button>
            <Button type="submit" bsStyle="success">
              Save
            </Button>
          </Modal.Footer>
        </form>
      );

    return (
      <Fragment>
        <Button
          className="btn-secondary"
          bsSize="xs"
          onClick={this.handleShowModal}
        >
          Edit
        </Button>
        <Modal show={show} onHide={this.handleCloseModal} backdrop="static">
          {form}
        </Modal>
      </Fragment>
    );
  }
}

export default ThemeEdit;
